var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.root},_vm._l((_vm.total),function(n){return _c('div',{key:n,class:_vm.computeStepClass(n),style:(_vm.computeStepStyle(n))},[_vm._v(" "+_vm._s(n)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }